import {useMemo} from 'react';
import {twMerge} from '../../../common/twMerge';
import {CharacterShowType} from '../../../domain/content/[seriesId]/viewer/[productId]/type/CharacterShowType.enum';
import {TalkPosition} from '../../../domain/content/[seriesId]/viewer/[productId]/type/TalkPosition.enum';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {TalkProfileProps} from './TalkProfileProps.interface';

export function TalkProfile({
  talkPosition,
  characterImgUrl,
  characterName,
  characterNameColor,
  characterShowType,
  className,
  ...props
}: TalkProfileProps) {
  const profileImg = useMemo(() => {
    const imageStyle = twMerge(
      'top-4tvs-minus h-80tvs w-80tvs overflow-hidden rounded-full',
      characterShowType === CharacterShowType.SpaceOnly && 'invisible',
      characterShowType === CharacterShowType.NameOnly && 'hidden'
    );
    if (characterImgUrl) {
      return (
        <img src={characterImgUrl} className={imageStyle} alt="프로필 아이콘" />
      );
    } else {
      return <Icon type={IconType.DefaultProfile} className={imageStyle} />;
    }
  }, [characterImgUrl, characterShowType]);

  if (
    talkPosition === TalkPosition.Center ||
    !talkPosition ||
    characterShowType === CharacterShowType.None
  ) {
    return null;
  }

  return (
    <div
      className={twMerge(
        'relative inline-flex',
        TALK_POSITION_STYLE[talkPosition],
        className
      )}
      {...props}
    >
      {profileImg}
      {(characterShowType === CharacterShowType.NameOnly ||
        characterShowType === CharacterShowType.Normal) && (
        <Text
          className={twMerge(
            'absolute inline-flex whitespace-pre text-28tvs font-medium opacity-60',
            talkPosition === TalkPosition.Left && 'left-full ml-6pxr',
            talkPosition === TalkPosition.Right && 'right-full mr-6pxr'
          )}
          style={{
            color: characterNameColor,
          }}
        >
          {characterName}
        </Text>
      )}
    </div>
  );
}

const TALK_POSITION_STYLE: {[key in TalkPosition]: string} = {
  [TalkPosition.Center]: '',
  [TalkPosition.Left]: 'justify-start left-0',
  [TalkPosition.Right]: 'justify-end right-0',
};
